const normalizeText = (value) => String(value || '').trim().toLowerCase();
const normalizeDownloadItems = (settings = {}) => {
  const normalizeItems = (items) => {
    if (!Array.isArray(items)) return [];
    return items
      .map((item) => {
        if (!item || typeof item !== 'object') return null;

        const link = typeof item.link === 'string' ? item.link.trim() : '';
        if (!link) return null;

        const type = typeof item.type === 'string' ? item.type.trim().toLowerCase() : '';
        return {
          link,
          type: type === 'lua' || type === 'json' || type === 'free' ? type : '',
        };
      })
      .filter(Boolean);
  };

  const raw = settings?.downloadItems;

  if (Array.isArray(raw)) {
    return normalizeItems(raw);
  }

  if (typeof raw === 'string' && raw.trim()) {
    try {
      return normalizeItems(JSON.parse(raw));
    } catch {
      return [];
    }
  }

  if (raw && typeof raw === 'object') {
    return normalizeItems(Object.values(raw));
  }

  return [];
};

export const normalizeCategory = (category) => {
  const raw = normalizeText(category).replace(/[_-]+/g, ' ');

  if (!raw) return 'other';
  if (raw === 'premium') return 'premium';
  if (raw === 'exclusive') return 'exclusive';
  if (raw === 'bundle') return 'bundle';
  if (raw === 'addon' || raw === 'addons') return 'addon';
  if (raw === 'other' || raw === 'others') return 'other';
  if (raw === 'free' || raw === 'free script' || raw === 'free scripts') return 'free';

  return raw;
};

export const normalizePremiumEquivalentCategory = (category) => {
  const normalized = normalizeCategory(category);
  return normalized === 'exclusive' ? 'premium' : normalized;
};

export const isExternalProduct = (product) => {
  const type = normalizeText(product?.Type || product?.type);
  return type === 'external';
};

export const isPurchasableCategory = (category) => {
  const normalized = normalizeCategory(category);
  return normalized !== 'other' && normalized !== 'free';
};

export const isPurchasableProduct = (product) => {
  if (!product) return false;
  const status = String(product.status || '').trim().toLowerCase();
  // Disabled (inactive) or private products cannot be purchased or renewed
  if (status === 'inactive' || status === 'private') {
    return false;
  }
  if (product.category === undefined || product.category === null || String(product.category).trim() === '') {
    return true;
  }
  return isPurchasableCategory(product.category);
};

export const isWishlistEligibleProduct = (product) => {
  if (!product) return false;
  return isPurchasableProduct(product) && !isExternalProduct(product);
};

export const isFreeScriptProduct = (product) => normalizeCategory(product?.category) === 'free';

export const resolveFreeScriptDownloadLink = (product, settings = {}) => {
  const direct =
    product?.freeDownloadLink ||
    product?.FreeDownloadLink ||
    product?.downloadLink ||
    product?.DownloadLink ||
    '';

  if (String(direct || '').trim()) {
    return direct;
  }

  const freeCatalogItem = normalizeDownloadItems(settings).find((item) => item.type === 'free');
  if (freeCatalogItem?.link) {
    return freeCatalogItem.link;
  }

  return settings?.universalScriptLink || '';
};
